import { Reveal, Chapter } from "../../lib/motion";
import { EXPORT_POINTS } from "../../data";
import { Ship, Globe2, FileText, Package, Truck, Tags } from "lucide-react";

const ICONS = [Globe2, Package, Ship, Tags, Truck, FileText];

// Approx positions (%) for pulsing export nodes over the map
const NODES = [
  { x: "22%", y: "42%" }, { x: "30%", y: "30%" }, { x: "48%", y: "35%" },
  { x: "55%", y: "55%" }, { x: "68%", y: "40%" }, { x: "80%", y: "48%" }, { x: "72%", y: "68%" },
];

export default function GlobalExport() {
  return (
    <section id="export" data-testid="export" className="relative py-24 md:py-32 bg-verra-blue overflow-hidden">
      <div className="absolute inset-0 grain-overlay pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <Chapter number="06" overline="Global Export" title="Shipping trust to businesses worldwide." dark />

        <div className="relative rounded-3xl border border-white/10 bg-white/[0.03] p-6 md:p-10 mb-14">
          <div className="relative w-full aspect-[2/1]">
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/8/80/World_map_-_low_resolution.svg"
              alt="World map"
              className="absolute inset-0 w-full h-full object-contain opacity-20 invert"
            />
            {NODES.map((n, i) => (
              <span key={i} className="absolute" style={{ left: n.x, top: n.y }}>
                <span className="relative flex h-3 w-3">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-verra-light opacity-75" />
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-verra-green" />
                </span>
              </span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {EXPORT_POINTS.map((p, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={p} delay={0.05 * i}>
                <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 h-full hover:bg-white/[0.08] transition-colors duration-300">
                  <Icon className="w-6 h-6 text-verra-light mb-3" />
                  <p className="text-white font-medium text-sm leading-snug">{p}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
